import React, {useState} from 'react';
import {Button, Paper, Box} from "@material-ui/core";
import WPAPI from 'wpapi'
import AddDialog from "./components/AddDialog";
import PayPal from "./components/PayPal";
import Table from "./components/Table"
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";

const App = () => {

    const wp = new WPAPI({
        endpoint: 'https://kinoglaz.info/wp-json',
    });
    wp.setHeaders('Authorization', 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wva2lub2dsYXouaW5mbyIsImlhdCI6MTU3ODY0NTQ5NiwibmJmIjoxNTc4NjQ1NDk2LCJleHAiOjE1ODY0MjE0OTYsImRhdGEiOnsidXNlciI6eyJpZCI6IjYifX19.BvG7ETBsUUXNc_SnXik2O-vPqdAbZEYu1SuOybgsK4M');
    wp.kgorders = wp.registerRoute('wp/v2', '/kgorders/(?P<id>)')

    const useStyles = makeStyles(theme => ({
        paper:{
            margin: theme.spacing(1),
            padding: theme.spacing(1),
        }
    }))
    const classes = useStyles();

    const [state, setState] = React.useState({
      data:
          []
    })

    const [transactionID, setTransactionID] = useState(null)
    const [orderID, setOrderID] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)

    const createOrder = ({ID, payer}) => {
        setTransactionID(ID)

        const items = state.data
        const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
        const header = Object.keys(items[0])
        let csv = items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
        csv.unshift(header.join(','))
        csv = csv.join('\r\n')

        wp.kgorders().create({
            title: payer + ' - ' + ID,
            status: 'private',
            content: csv
        }).then(function (response) {
            // "response" will hold all properties of your newly-created post,
            // including the unique `id` the post was assigned on creation
            console.log(response.id);
            setOrderID(response.id)
        }).catch(function( err ) {
            console.error(err)
        });
    }


    const save = (persona) => {
        setState((prevState) => {
                return {
                    data: [
                        ...prevState.data,
                        persona
                    ]
                }
            }
        )

        setDialogOpen(false)
    }

    const [dialogOpen, setDialogOpen] = useState(false)

    const [calcolato, setcalcolato] = useState(null)
    const [tessere, setTessere] = useState(0)

    const calcolaImporto = () => {
        let num_tessere = 0;
        state.data.forEach((persona) => {if(!persona.socio2020) {num_tessere++}});
        let importo = num_tessere + state.data.length * 5.00;
        setcalcolato(importo);
        setTessere(num_tessere);
    }


    return (<Box>
        <Table data={state.data} setState={setState} calcolato={calcolato}/>
        {(!calcolato && <DialogActions>
        {(state.data.length > 0 && <Button onClick={calcolaImporto} variant={"contained"}>Salva e calcola l'importo</Button>)}
        <Button onClick={() => setDialogOpen(true)} variant={"contained"}>Aggiungi un nominativo</Button>
        </DialogActions>)}
        {(calcolato && !transactionID && !orderID && <Paper className={classes.paper}>
            <Typography variant={"body1"}>L'importo da pagare per {tessere} tessere Kinoglaz 2020 + {state.data.length} contributi alla proiezione è di €{calcolato}.</Typography>
            <PayPal number={calcolato} onsuccess={createOrder} catcherror={setErrorMessage}/>
        </Paper>)}
        {(calcolato && transactionID && orderID && <Paper className={classes.paper}>
                <Typography variant={"body1"}>Il pagamento dell'ordine è stato registrato. Il nome dell'acquirente indicato su PayPal verrà indicato come riferimento per la richiesta biglietti in cassa entro un quarto d'ora prima dell'inizio della proiezione.</Typography>
            </Paper>
        )}
        {(calcolato && transactionID && !orderID && <Paper className={classes.paper}>
                <Typography variant={"body1"}>Il pagamento dell'ordine è stato registrato, ma si è verificato un errore nei nostri sistemi. Vi preghiamo di contattarci.</Typography>
            </Paper>
        )}
        {(errorMessage && <Paper className={classes.paper}>
                <Typography variant={"body1"}>Si è verificato un errore: {errorMessage}. Vi preghiamo di contattarci per segnalare l'accaduto.</Typography>
            </Paper>
            )}
        <AddDialog open={dialogOpen} save={save} chiudi={() => setDialogOpen(false)}/>
    </Box>)
}


export default App;
